"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Microphone = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 11,
  height: 16,
  viewBox: "0 0 11 16"
}, props), _react.default.createElement("path", {
  className: "fill",
  "clip-rule": "evenodd",
  d: "M5.813 13.292V14.667H3.75C3.37 14.667 3.062 14.965 3.062 15.333C3.0633 15.422 3.08214 15.5099 3.11744 15.5916C3.15273 15.6733 3.20379 15.7472 3.26769 15.8092C3.33159 15.8711 3.40708 15.9199 3.48984 15.9526C3.5726 15.9853 3.66101 16.0015 3.75 16H9.25C9.33899 16.0015 9.4274 15.9853 9.51016 15.9526C9.59292 15.9199 9.66841 15.8711 9.73231 15.8092C9.79621 15.7472 9.84727 15.6733 9.88256 15.5916C9.91786 15.5099 9.9367 15.422 9.938 15.333C9.938 14.965 9.63 14.667 9.25 14.667H7.187V13.292C8.76288 13.1015 10.1319 12.2645 11.0027 11.0633L10.0224 10.083C9.29785 11.2329 7.99128 12 6.5 12C4.222 12 2.375 10.21 2.375 8V6.667C2.375 6.298 2.068 6 1.688 6C1.308 6 1 6.298 1 6.667V8C1 10.72 3.099 12.964 5.813 13.292ZM10.5893 8.52855L11.7264 9.66565C11.904 9.14159 12 8.58168 12 8V6.667C12 6.298 11.693 6 11.313 6C10.933 6 10.625 6.298 10.625 6.667V8C10.625 8.17919 10.6129 8.35562 10.5893 8.52855ZM9.25 7.18923L3.8888 1.82802C4.25131 0.766095 5.28326 0 6.5 0C8.019 0 9.25 1.194 9.25 2.667V7.18923ZM3.75 3.81055L9.01655 9.0771C8.58985 10.0135 7.62373 10.667 6.5 10.667C4.981 10.667 3.75 9.473 3.75 8V3.81055Z"
}), _react.default.createElement("path", {
  className: "fill",
  d: "M0.217937 2.27023C-0.0726454 1.97964 -0.0726456 1.50852 0.217936 1.21794C0.508518 0.927355 0.979645 0.927355 1.27023 1.21794L12.7821 12.7298C13.0726 13.0204 13.0726 13.4915 12.7821 13.7821C12.4915 14.0726 12.0204 14.0726 11.7298 13.7821L0.217937 2.27023Z"
}));

var _default = Microphone;
exports.default = _default;